import { createStyles, makeStyles } from "@material-ui/core";

export const usePickupOrDeliverStyles = makeStyles(() =>
  createStyles({
    thereAreNotValue: {
        borderRadius: "4px", 
        border: "solid 1px #757a93", 
        backgroundColor: "rgba(142, 148, 173, 0.12)" , 
        padding: "13px 18px",
        textAlign: "center",
        cursor: "pointer",
        fontFamily: "Montserrat",
        fontWeight: "bold",
        color: "#757a93",
        fontSize: "14px",
       " &:hover ":{
          border: "1px solid #399ebf",
          color: "#399ebf",
        }
    },
    thereAreValues: {
        borderRadius: "4px", 
        border: "solid 1px #399ebf", 
        backgroundColor: "#e2f4fb" ,
        padding: "13px 18px",
        textAlign: "center"
    }
  })
);

